import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {Observable} from 'rxjs';
import {ApiUserDataFromRegistrationTokenResponse} from './api-user-data-from-registration-token-response';
import {ApiRegistrationRequest} from './api-registration-request';
import {ApiForgotPasswordRequest} from './api-forgot-password-request';
import {ApiResetPasswordRequest} from './api-reset-password-request';
import {AuthApiRoutesEnum} from '../../../../core/services/http/auth-api-routes.enum';
import {ApiExpiredPasswordRequest} from './api-expired-password-request';

@Injectable()
export class AuthenticationRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestUserDataFromRegistrationToken(token: string): Observable<ApiUserDataFromRegistrationTokenResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.REGISTRATION,
      token,
    ].join('/');
    return this._httpClient.get<ApiUserDataFromRegistrationTokenResponse>(url);
  }

  public requestRegistration(data: ApiRegistrationRequest): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.REGISTRATION,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }

  public requestPasswordResetLink(data: ApiForgotPasswordRequest): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.FORGOT_PASSWORD,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }

  public requestPasswordReset(data: ApiResetPasswordRequest): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.RESET_PASSWORD,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }

  public requestPasswordExpired(data: ApiExpiredPasswordRequest): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.EXPIRED_PASSWORD,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }
}
